<template>
    <div class="cc-kpi-card">
        <div class="cc-kpi-card__label">
            <span>{{ label }}</span>
            <q-icon v-if="info" name="info_outline" size="13px" color="grey-6" class="cc-kpi-card__info">
                <q-tooltip anchor="top middle" self="bottom middle" :offset="[0, 6]" max-width="240px" class="bg-grey-9" style="font-size: 10px;">{{ info }}</q-tooltip>
            </q-icon>
        </div>
        <div class="cc-kpi-card__value" :class="{ 'cc-kpi-card__value--off-target': offTarget }">{{ value }}</div>

        <div v-if="showDelta" class="cc-kpi-card__delta">
            <template v-if="delta">
                <q-icon v-if="delta.direction !== 'flat'" :name="delta.direction === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'" size="18px" class="cc-kpi-card__delta-icon"/>
                <span>{{ delta.text }} vs prior cycle</span>
            </template>
            <span v-else>No prior cycle data</span>
        </div>

        <div v-if="target" class="cc-kpi-card__target">{{ target }}</div>
    </div>
</template>

<script>
export default {
    name: "CommandCenterKpiCard",

    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: "—",
        },
        offTarget: {
            type: Boolean,
            default: false,
        },
        // { direction: "up" | "down" | "flat", text }, or null when the prior cycle has no data.
        delta: {
            type: Object,
            default: null,
        },
        // Off when the figures cover a custom date range, which has no prior cycle to compare against.
        showDelta: {
            type: Boolean,
            default: true,
        },
        target: {
            type: String,
            default: "",
        },
        // Definition of the KPI, shown in a tooltip on the info icon next to the label.
        info: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.cc-kpi-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 12px 16px;
    border: 1px solid #dedede;
    border-radius: 8px;
    background: #ffffff;
}

.cc-kpi-card__label {
    display: flex;
    align-items: center;
    color: #414141;
    font-size: 11px;
    font-weight: 600;
}

.cc-kpi-card__info {
    margin-left: 4px;
    cursor: help;
}

.cc-kpi-card__value {
    margin-top: 6px;
    color: #262626;
    font-size: 30px;
    font-weight: 700;
    line-height: 1;
}

.cc-kpi-card__value--off-target {
    color: #ff4e00;
}

.cc-kpi-card__delta {
    display: flex;
    align-items: center;
    margin-top: 8px;
    color: #5f5f5f;
    font-size: 10px;
}

.cc-kpi-card__delta-icon {
    margin: 0 -2px 0 -5px;
}

.cc-kpi-card__target {
    margin-top: 2px;
    color: #9f9f9f;
    font-size: 10px;
}
</style>
